import React, { useState, useRef} from "react";
import { Link } from "react-router-dom";
import { FaEye, FaEyeSlash, FaUserPlus } from "react-icons/fa";
import { MdPerson, MdEmail, MdLock } from "react-icons/md";
import {activatorUserAdding} from "../../auth";
import { elakayAutoText } from "../../pageInside/dataElakay";


let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["addinforUser"]?.[key] || fallback;

const AddinfoUser = (props) => {
    const {
        setPagesUser,
        bnTelephone,
        setUserInfo,
        token,
        infoSource,
        checkInfoUser,
        userInfo
        } = props
        __setElakayInfoSource(infoSource);

        let userValue ={
            firstname: "",
            lastname: "",
            email: "",
            emailRole: "",
            password: "",
            passwordConfirmation: "",
            error: "",
            success: false
        }
    const [showPassword, setShowPassword] = useState(true) 
    const [showPasswordConfirmation, setShowPasswordConfirmation] = useState(true) 
    const [values, setValues] = useState(userValue)
;

    const { firstname, lastname, password, email, passwordConfirmation, success, error} = values;
    const CheckEmail = !checkInfoUser(userInfo, 'email', 'edit') ? email !== "" :  email === ""
    const productTrue = firstname !== "" && lastname !== "" && password !== "" && passwordConfirmation !== "" && password === passwordConfirmation && CheckEmail

    const firstnameRef = useRef(null);
    const lastnameRef = useRef(null);
    const emailRef = useRef(null);
    const passwordRef = useRef(null);
    const passwordConfirmationRef = useRef(null);

    const scrollToFirstMissing = () => {
        const fields = [
            [firstname, firstnameRef],
            [lastname, lastnameRef],
            [!checkInfoUser(userInfo, 'email', 'edit') ? email : "ok", emailRef],
            [password, passwordRef],
            [passwordConfirmation, passwordConfirmationRef],
        ];
        const missing = fields.find(([value]) => !value);
        if (missing && missing[1].current) {
            missing[1].current.scrollIntoView({ behavior: "smooth", block: "center" });
            missing[1].current.focus?.();
        }
    };

    const handleChange = firstname => event => {
        setValues({ ...values, error: false, [firstname]: event.target.value });
    };

    // const activeButton = ()=>{
    //     let a = numberR > 0 || numberR != ''
    //     let b = numberS > 0 || numberS != ''
    //     let c = numberP > 0 || numberP != ''
    //     let d = numberAS > 0 || numberAS != ''
    //     let e = numberI > 0  || numberI != ''
    //     let f = numberA > 0 || numberA != ''
    //     let p = password != ''

    //     let g1Form = selectRole >= 4 && a && b && c && p
    //     let g2Form = selectRole >= 5 && g1Form && d 
    //     let g3Form = selectRole >= 6 && g2Form  && e
    //     let g4Form = selectRole >= 7 &&   g3Form && f
    //     if(selectRole === 4){
    //         return g1Form
    //     } else if(selectRole === 5) {
    //         return g2Form
    //     } else if(selectRole === 6) {
    //         return g3Form
    //     }else if(selectRole === 7) {
    //         return g4Form
    //     }else{
    //         return false
    //     }
    // }

    const clickSubmit = event => {
       let userEle =   !checkInfoUser(userInfo, 'email', 'edit') ? 
       {firstname, lastname, email, password, passwordConfirmation}:
       {firstname, lastname, password, passwordConfirmation};

        event.preventDefault();
        activatorUserAdding( token, 'user', userEle , true).then(data => {
            if (data.error) {
                setValues({ ...values, error: data.error, success: false });
            } else {
                if(!data){
                    setValues({ ...values, error: __elakayText("t001", "BAD REQUEST or email is not ok"), success: false });
                }else{
                userValue.success = true
                setValues(userValue);
                setUserInfo(data)
                setPagesUser(bnTelephone)
            }
            }
        });;
    };

    const showError = () => (
        <div
            className="uart-alert uart-alert-danger"
            style={{ display: error ? "" : "none" }}
        >
            {error}
        </div>
    );

    const showSuccess = () => (
        <div
            className="uart-alert uart-alert-success"
            style={{ display: success ? "" : "none" }}
        >
            {/* Your account elakay is created. Please  go to your email to validate your account */}
            {infoSource.language(infoSource, "text", "textAddinFUs")}
            <Link to="/signin">{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).addUserAddinforUser.t001}</Link>
        </div>
    );
    const signUpForm = () => (

            <form className="form-signin uart-user-form">
                <div className="uart-form-header">
                    <div className="uart-form-icon-wrapper">
                        <div className="uart-form-icon-circle">
                            <FaUserPlus />
                        </div>
                    </div>
                    <h4 className="uart-form-title">
                    {/* {infoSource.laguangeElakay('Button', infoSource.languageAPI).creatAccount} */}
                    {/* Add your info to continue */}
                    {infoSource.language(infoSource, "text", "textAddinFUs0")}
                    </h4>
                </div>
                {showSuccess()}
                {showError()}
                <div className="form-label-group uart-field">
                    <label className="text-muted" htmlFor="firstname">{infoSource.laguangeElakay('label', infoSource.languageAPI).fisrtName}</label>
                    <div className="uart-input-wrapper">
                        <span className="uart-input-icon-wrapper"><MdPerson className="uart-input-icon" /></span>
                        <input ref={firstnameRef} autoComplete="off" onChange={handleChange("firstname")} value={firstname} type="text" name="firstname" id="firstname" className="form-control" placeholder={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).addUserAddinforUser.t002} required/>
                    </div>
                </div>

                <div className="form-label-group uart-field">
                    <label htmlFor="lastname">{infoSource.laguangeElakay('label', infoSource.languageAPI).lastName}</label>
                    <div className="uart-input-wrapper">
                        <span className="uart-input-icon-wrapper"><MdPerson className="uart-input-icon" /></span>
                        <input ref={lastnameRef} autoComplete="off" onChange={handleChange("lastname")} value={lastname} type="text" name="lastname" id="lastname" className="form-control" placeholder={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).addUserAddinforUser.t003} required />
                    </div>
                </div>

              {  !checkInfoUser(userInfo, 'email', 'edit') && <div className="form-label-group uart-field">
                    <label htmlFor="inputEmail">{infoSource.laguangeElakay('label', infoSource.languageAPI).email}</label>
                    <div className="uart-input-wrapper">
                        <span className="uart-input-icon-wrapper"><MdEmail className="uart-input-icon" /></span>
                        <input ref={emailRef} autoComplete="off" onChange={handleChange("email")} value={email} type="email" name="email" id="inputEmail" className="form-control" placeholder={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).addUserAddinforUser.t004} required />
                    </div>
                </div>}

                <div className="form-label-group uart-field uart-password-field">
                    <label htmlFor="inputPassword">{infoSource.laguangeElakay('label', infoSource.languageAPI).Password}</label>
                    <div className="uart-input-wrapper">
                        <span className="uart-input-icon-wrapper"><MdLock className="uart-input-icon" /></span>
                        <input ref={passwordRef} autoComplete="off" onChange={handleChange("password")} value={password} type={showPassword ? "password" : "text"} name="password" id="inputPassword" className="form-control" placeholder={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).addUserAddinforUser.t005} aria-invalid={passwordConfirmation !== "" && password !== passwordConfirmation} />
                        <button type="button" className="uart-password-toggle" onClick={() => setShowPassword(!showPassword)} aria-label={showPassword ? elakayAutoText("h_044b852f30b636", "Show password") : elakayAutoText("h_e40123b4e7879a", "Hide password")}>{showPassword ? <FaEye /> : <FaEyeSlash />}</button>
                    </div>
                </div>

                <div className="form-label-group uart-field uart-password-field">
                    <label htmlFor="inputPassword2">{infoSource.laguangeElakay('label', infoSource.languageAPI).confirmPassword}</label>
                    <div className="uart-input-wrapper">
                        <span className="uart-input-icon-wrapper"><MdLock className="uart-input-icon" /></span>
                        <input ref={passwordConfirmationRef} autoComplete="off" onChange={handleChange("passwordConfirmation")} value={passwordConfirmation} type={showPasswordConfirmation ? "password" : "text"} name="passwordConfirmation" id="inputPassword2" className="form-control" placeholder={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).addUserAddinforUser.t006} aria-invalid={passwordConfirmation !== "" && password !== passwordConfirmation} required />
                        <button type="button" className="uart-password-toggle" onClick={() => setShowPasswordConfirmation(!showPasswordConfirmation)} aria-label={showPasswordConfirmation ? elakayAutoText("h_044b852f30b636", "Show password") : elakayAutoText("h_e40123b4e7879a", "Hide password")}>{showPasswordConfirmation ? <FaEye /> : <FaEyeSlash />}</button>
                    </div>
                </div>

                <input type="hidden" name="verication" placeholder="" />

                { productTrue ?
                <button type="button" onClick={clickSubmit} className="btn btn-lg btn-block uart-btn uart-form-submit">
                    {/* {infoSource.laguangeElakay('Button', infoSource.languageAPI).creatAccount} */}{__elakayText("t002", "save")}</button>:
                     <button type="button" onClick={scrollToFirstMissing} className="btn btn-lg btn-block uart-btn uart-form-submit uart-btn-disabled" aria-disabled="true">
                     {/* {infoSource.laguangeElakay('Button', infoSource.languageAPI).creatAccount} */}{__elakayText("t002", "save")}</button>

                }
                 </form>
    );

    return (
       <>
       { signUpForm() }
       </>
    );
};

export default AddinfoUser;
